// import React from 'react'
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

// const TermsConditions = () => {
//   const docs = [
//     {
//       uri:require("./Terms-of-Use.pdf"),
//     },

//   ];
//   return (
//     <div>
//       <DocViewer
//         documents={docs}
//         pluginRenderers={DocViewerRenderers}
//         style={{ height: 600, overflow: "auto", padding:0 }}
//         config={{
//           header: { disableHeader: true },
//           pdfZoom: {
//             defaultZoom: 1.1, // 1 as default,
//             zoomJump: 0.2, // 0.1 as default,
//           },
//           pdfVerticalScrollByDefault: true, // false as default
//         }}
//       />
//     </div>
//   );
// }

// export default TermsConditions

const TermsConditions = () => (
  <div className="mx-auto max-w-3xl px-6 py-16 text-center">
    <h1 className="text-3xl font-semibold text-gray-900">Terms and Conditions</h1>
    <p className="mt-4 text-gray-600">
      Terms and conditions are currently unavailable. Please contact support for the latest terms.
    </p>
  </div>
);

export default TermsConditions;
